import { push } from 'react-router-redux';
import { fetchCategory } from './fetch-category';
import { fetchPost } from './fetch-post';

const defaultUrlBuilder = (category, post, search) => `/${category.slug}/${post.slug}${search}`;

export const fetchPostAndRedirect = (categoryId, postId, search, urlBuilder = defaultUrlBuilder) => {
  return dispatch => {
    return Promise.all([dispatch(fetchCategory(categoryId)), dispatch(fetchPost(postId))]).then(results => {
      const category = results[0];
      const post = results[1];

      const isCategorySlugDiffers = categoryId !== category._id && categoryId !== category.slug;
      const isPostSlugDiffers = postId !== post._id && postId !== post.slug;

      if (isCategorySlugDiffers || isPostSlugDiffers) {
        dispatch(push({ pathname: urlBuilder(category, post, search), state: 301 }));
      }

      return post;
    });
  };
};



// WEBPACK FOOTER //
// ./app/actions/fetch-post-and-redirect.js